export const tooltipStyle = {
  maxWidth: "90ch",
  wordWrap: "break-word",
};
